export default __webpack_public_path__ + "static/media/SpecialistBG.1177be34.png";